import React, { useEffect } from "react";
import Grid from "../../assets/Grid.png";
import { Mail, Phone } from "lucide-react";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import Footer from "./Footer";
// import { Script } from "../../Utils/Script";

const Deleteaccount = () => { 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   Script();
  // }, []);

  return (
    <>
    <Helmet>
    <title>Delete Your Packky Account — Data Removal Request</title>

    <meta
      name="description"
      content="Want to delete your Packky account? Email support@packky.com from your registered address. Your account and data will be removed within 7 business days."
    />
  </Helmet>
      <Navbar />
      
   <div className="w-full">
  <section>
    <div
      className="mx-auto flex h-[220px] w-full items-center px-4 sm:h-[260px] sm:px-8 md:h-[300px] md:px-16 lg:h-[320px] lg:px-20"
      style={{
        background:
          "linear-gradient(180deg, #fff 0, #0000), radial-gradient(circle at 10% 100%, #8cffdd 0, #0000 30%), radial-gradient(circle at 40% 100%, #ff8cd1 0, #0000 40%), radial-gradient(circle at 100% 100%, #c68cff 0, #0000 55%)",
      }}
    >
      <div>
        <p className="mb-3 mt-28 text-[22px] font-medium text-[#6b6b6b] sm:text-[26px] md:mb-4 md:text-[28px]">
          Packky
        </p>

        <h2 className="text-[22px] font-bold uppercase leading-none text-[#212529] sm:text-[24px] md:text-[26px]">
          Delete Account
        </h2>
      </div>
    </div>
  </section>

  <div
    className="bg-[#ffeef8] bg-cover bg-center px-3 py-6 sm:px-4 sm:py-8 md:py-10"
    style={{
      backgroundImage: `url(${Grid})`,
    }}
  >
    <div className="mx-auto w-full max-w-6xl rounded-2xl bg-white p-4 shadow-sm sm:p-6 md:p-8">
      <h2 className="text-xl font-semibold leading-snug text-gray-900 sm:text-2xl md:text-[28px]">
        Delete Your Account — Packky App
      </h2>

      <div className="mt-4 text-sm leading-7 text-gray-700 sm:text-base">
        <div className="mb-3 md:text-[18px]">
          If you would like to request the deletion of your Packky account and
          all associated personal data, please follow the steps below:
        </div>

        <div className="mb-2">
          <h6 className="text-base font-semibold md:text-[22px] text-[#525252]">
            How to Request Account Deletion
          </h6>
        </div>

        <ul className="mb-4 list-disc space-y-2 pl-5">
          <li className="md:text-[18px]">
            Send an email to support@packky.com from your registered email
            address.
          </li>
          <li className="md:text-[18px]">
            Mention your registered username and request for account deletion.
          </li>
          <li className="md:text-[18px]">
            Our support team will verify your details and process the deletion.
          </li>
        </ul>

        <div className="mb-2">
          <h6 className="text-base md:text-[22px] font-semibold text-[#525252]">
            What Data Will Be Deleted
          </h6>
        </div>

        <ul className="mb-4 md:text-[18px] list-disc space-y-2 pl-5">
          <li>Your account information (name, phone number, email address)</li>
          <li>Your profile and login credentials</li>
          <li>Delivery and activity history</li>
        </ul>

        <div className="mb-2">
          <h6 className="text-base md:text-[22px] font-semibold text-[#525252]">
            Data Retention Policy
          </h6>
        </div>

        <ul className="mb-4 list-disc space-y-2 pl-5">
          <li className="md:text-[18px]">
            Some information, such as financial transactions or tax records, may
            be retained for up to 180 days after account deletion, as required
            by applicable laws.
          </li>
          <li className="md:text-[18px]">
            After the retention period, this data will also be permanently
            deleted.
          </li>
        </ul>

        <div className="mb-2">
          <h6 className="text-base md:text-[22px] font-semibold text-[#525252]">
            Processing Timeline
          </h6>
        </div>

        <ul className="mb-4 list-disc space-y-2 pl-5">
          <li className="md:text-[18px]">
            Your account and associated data will be deleted within 7 business
            days after we receive your deletion request.
          </li>
        </ul>

        <div className="mb-1">
          <h6 className="text-base md:text-[22px] font-semibold text-[#525252]">
            Need Help?
          </h6>
        </div>

        <div className="md:text-[18px]">
          For any questions or concerns, please contact us at:
        </div>

        <p className="mt-2 flex items-center gap-2 break-words text-gray-800 md:text-[18px]">
  <Mail className="h-5 w-5 text-green-900" />

  <a
    href="mailto:support@packky.com"
    className="text-blue-600 underline"
  >
    support@packky.com
  </a>
</p>

<p className="flex items-center mt-3 gap-2 break-words text-gray-800 md:text-[18px]">
  <Phone className="h-5 w-5 text-red-600" />

  <a
    href="tel:+919958853167"
    className="text-blue-600 underline"
  >
    +91-9958853167
  </a>
</p>
      </div>
    </div>
  </div>
</div>
<Footer/>
</>
  );
};

export default Deleteaccount;
